import React, { useContext } from 'react';
import { styled } from '@linaria/react';
import { Button } from '@daedalus/atlas/Button';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { PriceSize } from '@daedalus/atlas/Price';
import { PriceComposition } from '@daedalus/atlas/PriceComposition';
import { Text } from '@daedalus/atlas/Text';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { getRoomLabels } from '@daedalus/core/src/offer/business/getRoomLabels';
import { SearchOffer } from '@daedalus/core/src/offer/types/SearchOffer';
import { OfferLayout } from '../../search/OfferLayout';
import { ProviderLogo } from '../../search/ProviderLogo';
import { MirroredIcon } from '../MirroredIcon';
import { AlternativeOffersContext } from './AlternativeOffersContext';
const CtaWrapper = /*#__PURE__*/styled('div')({
  name: "CtaWrapper",
  class: "cjunj2t",
  propsAsIs: false
});
type BaseOfferProps = {
  offer: SearchOffer;
};
const PrimaryWrapper = /*#__PURE__*/styled('section')({
  name: "PrimaryWrapper",
  class: "p9pd308",
  propsAsIs: false
});
const OfferLabels: React.FC<{
  offer: SearchOffer;
}> = ({
  offer
}) => {
  const labels = getRoomLabels({
    offer,
    shouldShowYourChoice: false
  });
  return <>
      {labels.map((label, index) => <>
          <FormattedMessageWrapper key={label.id} {...label} />
          {index !== labels.length - 1 && ' · '}
        </>)}
    </>;
};
const OfferPrice = ({
  offer,
  size
}: {
  offer: SearchOffer;
  size?: PriceSize;
}) => {
  const {
    showTotalPrices
  } = useContext(AlternativeOffersContext);
  return <PriceComposition size={size} price={showTotalPrices ? offer.totalRate : offer.nightlyRate} anchorPrice={0} currencyCode={offer.currency} />;
};
export const Primary: React.FC<BaseOfferProps> = ({
  offer
}) => {
  return <PrimaryWrapper>
      <OfferLayout variant="PrimaryMultiColumn" providerLogoComponent={<ProviderLogo providerCode={offer.intermediaryProvider} />} roomNameComponent={<Text variant="labelS">{offer.roomName}</Text>} roomLabelsComponent={<Text colorPath="content.featured.c600" variant="bodyXS">
            <OfferLabels offer={offer} />
          </Text>} priceComponent={<OfferPrice offer={offer} size="xl" />} ctaComponent={<CtaWrapper>
            <Button>
              <FormattedMessageWrapper id="viewDeal" defaultMessage="View Deal" />
            </Button>
          </CtaWrapper>} />
    </PrimaryWrapper>;
};
export const Secondary: React.FC<BaseOfferProps> = ({
  offer
}) => {
  return <OfferLayout variant="SecondaryDefault" providerLogoComponent={<ProviderLogo providerCode={offer.intermediaryProvider} />} roomLabelsComponent={<Text colorPath="content.neutral.c600" variant="bodyXS">
          <OfferLabels offer={offer} />
        </Text>} priceComponent={<OfferPrice offer={offer} size="sm" />} ctaComponent={<ContentWrapper paddingLeft="s200">
          <MirroredIcon name={'ChevronRight'} size="sm" colorPath="content.neutral.c600" />
        </ContentWrapper>} />;
};

require("./Offer.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Offer.tsx");